import {
    GET_MYTASK,
    GET_INPROGRESS,
    UPDATE_STATUS_TRANSACION
} 
from '../actions/actionTypes';

const initialState = {
    myTask:[],
    inProgress:[],
    resultUpdateStatus:[]
  };
  
function MyTaskRedux(state = initialState, action) {
  switch (action.type) {
    case GET_MYTASK:
      return {
        ...state,
        myTask: action.payload
      };
    case GET_INPROGRESS:
      return {
        ...state,
        inProgress: action.payload
      };
    case UPDATE_STATUS_TRANSACION:
      return {
        ...state,
        resultUpdateStatus: action.payload
      };
    default:
      return state;
  }
}

export default MyTaskRedux;
